import type { TransactionType } from '../correction-tool.models';

export const getColumnsByTransactionType = (
  transactionType: TransactionType,
) => {
  switch (transactionType) {
    case 'directDebits':
      return ['name', 'creditorId', 'mref', 'purpose', 'sequenceType'];
    case 'standingOrders':
      return [
        'name',
        'iban',
        'bankCode',
        'purpose',
        'amount',
        'interval',
        'executionDay',
        'nextExecution',
        'firstExecution',
        'lastExecution',
        'suspensionFrom',
        'suspensionTo',
        'type',
      ];
    case 'receivedPayments':
      return ['name', 'purpose', 'amount'];
    default:
      return [];
  }
};
